<div class="b2a-exercisesContainer">
  <div class="b2a-exercisesContainer__header">
    <app-chips-list *ngIf="displayCategories" class="b2a-exercisesContainer__filter">
      <app-chip (select)="filter()" selected="true">{{ 'EXERCISES.categoryAll' | translate }}</app-chip>

      <app-chip (select)="filter(cat)" *ngFor="let cat of mainCategories">{{
        cat.title[translate.currentLang]
      }}</app-chip>
    </app-chips-list>

    <div *ngIf="displaySalmagundiIndicator" class="b2a-exercisesContainer__challenge-info">
      <div class="b2a-exercisesContainer__challenge-info-box"></div>
      {{ 'CHALLENGE.countedForSalmagundi' | translate }}
    </div>
  </div>

  <div class="b2a-exercisesContainer__inner">
    <app-box
      *ngFor="let ex of exercises | categoryfilter : filterargs"
      boxType="ex"
      type="play"
      [showBorder]="displaySalmagundiIndicator && completedSalmagundiExerciseIds.includes(ex._id)"
      [preview]="ex.previewUrl"
      [videoUrl]="ex.videoUrl.de"
      [title]="ex.title[translate.currentLang]"
      [categories]="ex.categories"
      (onSelect)="openVideoDialog(ex)"
      [@box]
    ></app-box>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/exercises/ex.component.html